import moment from 'moment'
import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import { Table } from 'semantic-ui-react'

import './Date.css'

class Date extends PureComponent {
  render() {
    const { date } = this.props
    if (!date) {
      return null
    }

    return (
      <Table.Cell className="RoundDate" colSpan="7" disabled>
        {date === '-' ? 'Fecha sin definir' : moment(date).format('ddd, DD [de] MMM YYYY')}
      </Table.Cell>
    )
  }
}

Date.propTypes = {
  date: PropTypes.string.isRequired,
}

export default Date
